import { getAdLists } from 'api/platform/mutualHelpV3.js'
import {
  getQaAnswerList,
  getQaQuestionDetail,
  getSimilarityProblem,
  getRelatedReading,
  getTeacherListAb,
  similarGroup,
  qingtingList
} from 'api/qa/questions.js'
import { posterShareData } from 'api/platform/commonApi.js'

const store = {
  namespaced: true,
  state: () => ({
    detail: {},
    teacherList: [],
    answerList: [],
    similarityProblem: [],
    relatedReading: [],
    adInfo: null,
    similarGroupList: [],
    qingtingList: [],
    shareData: {}
  }),
  mutations: {
    setAdInfo(state, obj) {
      state.adInfo = obj
    },
    setDetail(state, obj) {
      state.detail = obj
    },
    setAnswerList(state, list) {
      state.answerList = list
    },
    setTeacherList(state, list) {
      state.teacherList = list
    },
    setSimilarityProblem(state, list) {
      state.similarityProblem = list
    },
    setRelatedReading(state, list) {
      state.relatedReading = list
    },
    setCollect(state, isFavorite) {
      state.detail.isFavorite = isFavorite
    },
    setSimilarGroup(state, list) {
      state.similarGroupList = list
    },
    setQingsu(state, list) {
      state.qingtingList = list
    },
    setPosterShareData(state, data) {
      state.shareData = data
    }
  },
  actions: {
    fetchQuestionDetail({ commit }, params) {
      return getQaQuestionDetail(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setDetail', res.data || {})
            return Promise.resolve(res)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchQaAnwserList({ commit }, params) {
      return getQaAnswerList(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setAnswerList', res.data || [])
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchTeacherListAb({ commit }, params) {
      return getTeacherListAb(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setTeacherList', res.data || [])
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchSimilarityProblem({ commit }, params) {
      return getSimilarityProblem(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setSimilarityProblem', res.data || [])
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchRelatedReading({ commit }, params) {
      return getRelatedReading(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setRelatedReading', res.data?.list || [])
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchFlowAd({ commit }, params) {
      params.token = params.token || '' // 未登录时防止签名失败
      return getAdLists(params)
        .then(res => {
          if (+res.code === 0) {
            const adList = res.data || []
            commit('setAdInfo', adList.length ? adList[0] : null)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchSimilarGroup({ commit }, params) {
      return similarGroup(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setSimilarGroup', res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchQingtingList({ commit }, params) {
      return qingtingList(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setQingsu', res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchPosterShareData({ commit }, params) {
      return posterShareData(params)
        .then(res => {
          if (+res.code === 0) {
            commit('setPosterShareData', res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}

export default {
  store,
  name: 'qaQuestionDetail'
}
